import { Switch } from "@/components/ui/switch";
import FormInputField from "@/components/lib/from-input-field";
import { Label } from "@/components/ui/label";
import SpiceSelector from "@/components/lib/SpiceSelector";
import { Button } from "@/components/ui/button";
import { PenLine, Trash2 } from "lucide-react";
import { useSelector } from "react-redux";

import CreateAddonsDialog from "@/components/dialog/menu-manage/common-dialog/create-addons";
import CreateAllergenDialog from "@/components/dialog/menu-manage/common-dialog/create-allergen";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import { useState, useEffect } from "react";
import { spiceLevels } from "@/assets/constans";
import { ButtonType } from "@/components/lib/Button";

function Step2({ form, standard_food_id }) {
  const { addOns } = useSelector((state) => state.essentialMenu.addOns);
  const { allergens } = useSelector((state) => state.essentialMenu.allergens);
  const spice_level = form.watch("spice_level");
  const allergen_ids = form.watch("allergen_ids");
  const [showSpice, setShowSpice] = useState(false);
  const [showAllergen, setShowAllergens] = useState(false);
  const [createNewAllergen, setCreateNewAllergen] = useState(false);
  const [createNewAddsOns, setCreateNewAddsOns] = useState(false);

  const closeNewAllergen = () => {
    setCreateNewAllergen(false);
  };

  const closeAddOns = () => {
    setCreateNewAddsOns(false);
  };

  useEffect(() => {
    setShowAllergens(Array.isArray(allergen_ids) && allergen_ids.length > 0);
    setShowSpice(!!spice_level);
  }, [allergen_ids, spice_level]);

  return (
    <Card className="max-w-screen-md bg-cblack6 mx-auto mt-10 text-cwhite">
      <CardHeader>
        <CardTitle>
          {form.watch("type") == "update"
            ? "Update Standard Foods"
            : "Add New Standard Foods"}{" "}
        </CardTitle>
        <CardDescription className="text-cyellow">
          Item name: {form.watch("name") || "No name"}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div
          // onSubmit={form.handleSubmit("")}
          className="flex flex-col gap-8 mt-5"
        >
          <div>
            <div className="flex gap-5 justify-between items-end">
              <div className="w-full">
                <FormInputField
                  name="price"
                  style="bg-cblack7 h-10"
                  placeholder={"Price"}
                  form={form}
                  type="text"
                  label={"Price"}
                />
              </div>
            </div>
          </div>

          <div>
            <div className="flex gap-5 justify-between items-end">
              <div className="w-full">
                <FormInputField
                  name="add_on_ids"
                  type="multiselect"
                  label="Add Ons"
                  style="w-full bg-cblack7"
                  placeholder="Select Add Ons"
                  selectOption={addOns?.filter((item) => item?.status === "active")?.map((item) => ({
                    label: item.name,
                    value: item.id,
                  }))}
                  form={form}
                />
              </div>
              <ButtonType onClick={() => setCreateNewAddsOns(true)}>
                Create New Add-ons
              </ButtonType>
              <CreateAddonsDialog
                title={"Create New Add-ons"}
                menu_id={standard_food_id}
                onClose={closeAddOns}
                isOpen={createNewAddsOns}
              />
            </div>
          </div>

          <div>
            <div className="flex gap-5 justify-between items-end mt-3">
              <div className="w-full">
                <div className="flex gap-2 items-center">
                  <Switch
                    checked={showAllergen}
                    onCheckedChange={(val) => {
                      setShowAllergens(val);
                      if (!val) {
                        form.setValue("allergen_ids", []);
                      }
                    }}
                  />
                  <Label>
                    Allergen{" "}
                    <span className="text-sm font-light">(shows on items)</span>
                  </Label>
                </div>
                {showAllergen && (
                  <div className="space-y-2 flex mt-2 w-full">
                    <FormInputField
                      name="allergen_ids"
                      style="bg-cblack7 flex-1"
                      placeholder={"Select Allergens"}
                      form={form}
                      type="multiselect"
                      label={"Allergens"}
                      selectOption={
                        allergens && allergens?.length > 0
                          ? allergens
                            .filter((item) => item?.status === "active")
                            .map((item) => ({
                              label:
                                item.name +
                                (item?.short_name ? ` (${item.short_name})` : ""),
                              value: item.id,
                            }))
                          : [
                              {
                                label: "Not available",
                                value: "",
                                disabled: true,
                              },
                            ]
                      }
                    />
                  </div>
                )}
              </div>
              {showAllergen && (
                <ButtonType onClick={() => setCreateNewAllergen(true)}>
                  Create New Allergen
                </ButtonType>
              )}
              <CreateAllergenDialog
                menu_id={standard_food_id}
                title={"Create New Allergen"}
                onClose={closeNewAllergen}
                isOpen={createNewAllergen}
              />
            </div>
          </div>

          <div>
            <div className="flex gap-5 justify-between items-end mt-3">
              <div className="w-full">
                <SpiceSelector form={form} />
              </div>
            </div>
          </div>
        </div>
      </CardContent>
      {/* all dialog */}
    </Card>
  );
}

export default Step2;
